import React, { useContext } from "react";
import AppContext from "../../context/AppContext";
import { useLocation } from "react-router-dom";

export const PageCard = ({ children, className = "" }) => {
  const { theme } = useContext(AppContext);
  const location = useLocation();

  const isMapTaskPage = location.pathname === "/maptask";
  const isTaskManagePage = location.pathname === "/task-manage";
  const isImportCsvPage = location.pathname === "/task/import-csv";
  const isRoleManagementPage = location.pathname === "/role-management";
  const isUserManagementPage = location.pathname === "/all-users";
  const isConfigurationPage = location.pathname === "/configuration";
  const isExportReportPage = location.pathname === "/export-report-and-data";
  const isSecurityPage =
    location.pathname === "/security" ||
    location.pathname === "/security/protection-jobs";
  const isOrganizationPage = location.pathname === "/organization";
const isReportsPage = location.pathname === "/reports";
const isStockManagementPage = location.pathname === "/stock-managment";
const isInventoryManagementPage =
  location.pathname === "/inventory-management";
const isWorklogPage = location.pathname === "/worklog";
const isPdfGeneratorPage = location.pathname === "/pdf-generator";
const isPdfExportHistoryPage = location.pathname === "/pdf-export-history";
  const isWorkflowPage = location.pathname === "/workflow";
  const isWorkflowFormPage = location.pathname === "/workflow-form";
const isCustomerSupportPage = location.pathname === "/customer-support";
  const isAppUpdateConfigPage = location.pathname === "/app-update-config";
  const isDashboardPage =
    location.pathname === "/" ||
    location.pathname === "/dashboard" ||
    location.pathname === "/activty-dashboard";
  const isFlushPage =
    isMapTaskPage ||
    isTaskManagePage ||
    isImportCsvPage ||
    isUserManagementPage ||
    isRoleManagementPage ||
    isConfigurationPage ||
    isExportReportPage ||
    isSecurityPage ||
    isOrganizationPage ||
    isReportsPage ||
    isStockManagementPage ||
    isInventoryManagementPage ||
    isWorklogPage ||
    isPdfGeneratorPage ||
    isPdfExportHistoryPage ||
    isWorkflowPage ||
    isCustomerSupportPage ||
    isAppUpdateConfigPage;

  return (
    <div
      className={`page-content-root w-full  flex flex-col box-border border-l-0 rounded-[16px] ${
        isFlushPage
          ? "h-full min-h-0 gap-0"
          : isDashboardPage
            ? "min-h-full gap-4 pt-4 pb-4 pl-4 pr-4"
            : isWorkflowFormPage
              ? "min-h-full gap-0 p-0"
              : "min-h-full gap-4 p-4"
      } ${
        theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
      } ${className}`}
      style={{
        boxSizing: "border-box",
        borderLeft: 0,
      }}
    >
      {children}
    </div>
  );
};

export default PageCard;
